<ion-app>
  <!-- Screen selection is decided by resolveSplashScreen (pure + unit-tested).
       'auth-error' is resolved first so a failed sign-in can't be masked by the
       spinner — the original infinite-splash bug. -->
  @switch (displaySplashScreen()) {
    @case ('auth-error') {
      <div class="flex-col justify-center items-center h-100">
        <sara-empty-state
          icon="triangle-exclamation"
          [title]="authErrorTitle"
          [hint]="authErrorHint">
          <button
            mat-flat-button
            class="btn-confirm"
            (click)="retryLogin()">
            {{ authErrorRetry }}
          </button>
        </sara-empty-state>
      </div>
    }
    @case ('spinner') {
      <div class="flex-col justify-center items-center h-100">
        <div class="loading-container">
          <img
            class="sarapilots-logo-home-img"
            src="assets/logos/sarapwi-dark-750px-72ppi.png"
            alt="Sara PWI" />
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      </div>
    }
    @case ('standalone-loading') {
      <!-- A replay tab is still booting: show its OWN loader here (identical to
           the one ReplayComponent renders once it mounts) so there's no
           app-spinner → replay-loader jump. -->
      <replay-loading-screen></replay-loading-screen>
    }
    @case ('no-access') {
      <div class="flex-col justify-center items-center h-100">
        <sara-empty-state
          icon="lock"
          title="PWI is not accessible for the moment"
          hint="Please try again later.">
          <button
            mat-flat-button
            class="btn-neutral"
            (click)="logout()">
            Logout
          </button>
        </sara-empty-state>
      </div>
    }
    @default {
      <ion-router-outlet></ion-router-outlet>
    }
  }
</ion-app>
